import { Hit } from "_shared/_api/search/search-results";
import Guid from "_shared/guids/guid";
import { MarketplaceResultType } from "config";
import { MarketplaceSearchInfoJSON } from "marketplace/_schema/marketplace-search-response-schema";

/**
 * The hits a picker draws, and how many it left out.
 *
 * The individuals search also returns unpublished members of a firm the caller may read. In a
 * picker such a person can be neither chosen nor published by anyone but themselves, so their card
 * draws nothing. The count comes from the search, so it has to leave them out too, or it reads "3
 * Results" over two cards. The caller's own unpublished profile stays: its card offers to publish it.
 */
export function getPickerSelectableResults(
  hits: Hit<MarketplaceSearchInfoJSON>[],
  viewerUserId: Guid | undefined,
): { hits: Hit<MarketplaceSearchInfoJSON>[]; leftOut: number } {
  const selectable = hits.filter((hit) => !isUnpublishedSomeoneElse(hit.data, viewerUserId));
  return { hits: selectable, leftOut: hits.length - selectable.length };
}

function isUnpublishedSomeoneElse(result: MarketplaceSearchInfoJSON, viewerUserId: Guid | undefined): boolean {
  if (result?.type !== MarketplaceResultType.Individual || result.isVisible !== false) return false;
  const userId = "userId" in result ? result.userId : undefined;
  return !(userId && viewerUserId?.isEqualTo(new Guid(userId)));
}
